import { EntityConfiguration, EntityType } from './types';
import { url } from 'constants/index';
export const ENTITY_CONFIGURATIONS: EntityConfiguration = {
  competitors: {
    contracts: '/contracts?pageSize=20&page={page}&filter=person.id[equals]:{personId}',
    fixtures: '/fixtures?pageSize=20&page={page}&filter=competitors.id[in]:{entityId}',
    seasons: '/competitors/{entityType}/{entityId}/seasons?pageSize=20&page={page}',
    rounds: '/competitors/{entityType}/{entityId}/rounds?pageSize=20&page={page}',
    officials: '/persons/{personId}/officials?pageSize=20&page={page}',
  },

  fixtures: {
    seasons: '/seasons?pageSize=20&page={page}&filter=fixtures[contains]:{entityId}',
    rounds: '/rounds?pageSize=20&page={page}&filter=fixtures[contains]:{entityId}',
    competitions: '/competitions?pageSize=20&page={page}&filter=fixtures[contains]:{entityId}',
  },

  seasons: {
    rounds: '/rounds?pageSize=20&page={page}&filter=season.id[equals]:{entityId}',
    seasoncompetitors: '/competitors?pageSize=20&page={page}&filter=seasons[contains]:{entityId}',
  },

  venues: {
    sports: '/venues/{entityId}',
    homeCompetitors: '/competitors/teams?pageSize=20&page={page}&filter=venue.id[equals]:{entityId}',
    fixtures: '/fixtures?pageSize=20&page={page}&filter=venue.id[equals]:{entityId}',
    subVenues: '/venues?pageSize=20&page={page}&filter=parentVenue.id[equals]:{entityId}',
  },
};

export const COMPETITOR_ENTITY_TYPES: EntityType[] = ['players', 'teams', 'doubles', 'horses'];

const PLAYERS_ENTITY_DATA = {
  lineups: '/competitors/players/{entityId}/lineups/count',
};

export const COUNT_ONLY_DATA_TYPES = new Set(['lineups']);

export const VENUE_DETAIL_FROM_ENTITY_DATA_TYPES = new Set(['sports']);

export const getEntityConfiguration = (entityType: EntityType) => {
  if (COMPETITOR_ENTITY_TYPES.includes(entityType)) {
    if (entityType === 'players') {
      return { ...ENTITY_CONFIGURATIONS.competitors, ...PLAYERS_ENTITY_DATA };
    }
    return ENTITY_CONFIGURATIONS.competitors;
  }

  return ENTITY_CONFIGURATIONS[entityType] || {};
};

export const getEntityEndpoint = (entityType: EntityType): string => {
  const endpointMap: Record<EntityType, string> = {
    organizations: '/organizations',
    competitions: '/competitions',
    seasons: '/seasons',
    rounds: '/rounds',
    fixtures: '/fixtures',
    persons: '/persons',
    players: url.players_datasource,
    doubles: '/competitors/doubles',
    teams: url.teams,
    horses: '/competitors/horses',
    venues: url.venue_datasource,
  };

  return endpointMap[entityType];
};

export const getMergeEndpoint = (entityType: EntityType): string =>
  entityType === 'venues' ? '/venues/duplicates' : '/competitors/duplicates';

export const getEntityDisplayName = (entityType: EntityType): string => {
  const displayNameMap: Record<EntityType, string> = {
    organizations: 'Organizations',
    competitions: 'Competitions',
    seasons: 'Seasons',
    rounds: 'Rounds',
    fixtures: 'Fixtures',
    persons: 'Persons',
    players: 'Players',
    doubles: 'Doubles',
    teams: 'Teams',
    horses: 'Horses',
    venues: 'Venues',
  };

  return displayNameMap[entityType];
};
